<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div v-if="!isLoaded">
                    <LoadingScreen></LoadingScreen>
                </div>
                <div v-if="isLoaded">
                    <div class="card">
                        <div class="p-3 pb-0 card-header">
                            <div class="d-flex flex-column flex-md-row justify-content-between">
                                <!-- Sección de Título -->
                                <div>
                                    <h6 class="ms-2">Desautorizar Registros de tiempo</h6>
                                </div>
                                <div class="d-flex">
                                    <div class=" d-flex align-items-center ms-2">
                                        <span class="ms-2"><b>Desautorizar PM:</b></span>
                                        <button class="btn btn-info mb-0 ms-2">
                                            <i class="bi bi-person-fill-slash"></i>
                                        </button>
                                    </div>
                                    <div class=" d-flex align-items-center ms-2">
                                        <span class="ms-2"><b>Desautorizar Gerencia:</b></span>
                                        <button class="btn btn-secondary mb-0 ms-2">
                                            <i class="bi bi-person-fill-dash"></i>
                                        </button>
                                    </div>
                                    <div class="d-flex align-items-center ms-2">

                                        <span class="ms-2"><b>Desautorizar Todo:</b></span>
                                        <button class="btn btn-dark mb-0 ms-2">
                                            <i class="bi bi-person-fill-exclamation"></i>
                                        </button>
                                    </div>
                                    <div class="d-flex align-items-center ms-2">
                                        <span class="ms-2"><b>Eliminar Registro:</b></span>
                                        <button class="btn btn-danger mb-0 ms-2">
                                            <i class="bi bi-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <label>Fecha Inicio:</label>
                                    <input type="date" class="form-control" v-model="startDate">
                                </div>
                                <div>
                                    <label>Fecha Fin:</label>
                                    <input type="date" class="form-control" v-model="endDate">
                                </div>
                                <div>
                                    <label>Registros:</label>
                                    <select class="form-control" v-model="filterOption" @change="handleFilterChange">
                                        <option value="all">Todos los registros</option>
                                        <option value="pm">Solo de PM</option>
                                        <option value="management">Solo de Gerencia</option>
                                    </select>
                                </div>
                                <div>
                                    <label>Buscar colaborador:</label>
                                    <input type="text" class="form-control" v-model="searchQuery">
                                </div>
                                <div>
                                    <br>
                                    <button class="btn btn-warning mb-0" @click="fetchRecords">Cargar datos</button>
                                </div>
                            </div>
                            <div class="table-responsive mt-4">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Colaborador</th>
                                            <th>Fecha</th>
                                            <th>Horas</th>
                                            <th>Extra?</th>
                                            <th>Acciones</th>
                                            <th>P.M.</th>
                                            <th>Autorizador</th>
                                            <th>Cliente</th>
                                            <th>Proyecto</th>
                                            <th>Actividad</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(tr, idx) in filteredRecords" :key="idx">
                                            <td>{{ tr.user_name }}</td>
                                            <td>{{ formatDateUTC(tr.date) }}</td>
                                            <td>{{ tr.total_hours }}</td>
                                            <td>{{ tr.is_extra_time ? 'SI' : 'NO' }}</td>
                                            <td>
                                                <button class="btn btn-info mb-0" @click="unAuthPM(tr.time_record_id)">
                                                    <i class="bi bi-person-fill-slash"></i>
                                                </button>
                                                <button class="btn btn-secondary mb-0 ms-2"
                                                    @click="unAuth(tr.time_record_id)">
                                                    <i class="bi bi-person-fill-dash"></i>
                                                </button>
                                                <button class="btn btn-dark mb-0 ms-2"
                                                    @click="unAuthAll(tr.time_record_id)">
                                                    <i class="bi bi-person-fill-exclamation"></i>
                                                </button>
                                                <button class="btn btn-danger mb-0 ms-2"
                                                    @click="deleteRecord(tr.time_record_id)">
                                                    <i class="bi bi-trash"></i>
                                                </button>
                                            </td>
                                            <td>{{ tr.project_manager }}</td>
                                            <td>{{ tr.authorizer }}</td>
                                            <td>{{ tr.client }}</td>
                                            <td>{{ tr.project }}</td>
                                            <td>{{ tr.activity }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>

import { ref, computed, onMounted } from "vue"

import LoadingScreen from "./components/LoadingScreen.vue";

import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const records = ref([])

const startDate = ref('')
const endDate = ref('')

const searchQuery = ref('')

const filteredRecords = computed(() => {
    const query = searchQuery.value.toLowerCase();
    return records.value.filter(tr =>
        (tr.user_name?.toLowerCase().includes(query))
    );
});

const setCurrentWeek = () => {
    const today = new Date()
    const dayOfWeek = today.getDay()
    const startOfWeek = new Date(today)
    const daysToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek
    startOfWeek.setDate(today.getDate() + daysToMonday)
    const endOfWeek = new Date(startOfWeek)
    endOfWeek.setDate(startOfWeek.getDate() + 6)

    startDate.value = startOfWeek.toISOString().split('T')[0]
    endDate.value = endOfWeek.toISOString().split('T')[0]
}
const isLoaded = ref(false)

const formatDateUTC = (dateString) => {
    const date = new Date(dateString)

    const day = String(date.getUTCDate()).padStart(2, '0')
    const month = String(date.getUTCMonth() + 1).padStart(2, '0')
    const year = date.getUTCFullYear()

    return `${day}/${month}/${year}`
}


const filterOption = ref('all')
const isAuth = ref(null)
const authByPM = ref(null)

// Maneja el cambio del select
const handleFilterChange = () => {
    switch (filterOption.value) {
        case 'all':
            // Todos los registros (sin filtrar por autorización)
            isAuth.value = null
            authByPM.value = null
            break
        case 'pm':
            // Solo autorizados por PM (is_auth puede ser 0 o 1)
            isAuth.value = null
            authByPM.value = 1
            break
        case 'management':
            // Solo autorizados por Gerencia (auth_by_pm puede ser 0 o 1)
            isAuth.value = 1
            authByPM.value = null
            break
    }
    
    fetchRecords()
}


const fetchRecords = async () => {

    const body = {
        start: startDate.value,
        end: endDate.value,
    }

    // Agregar filtros solo si tienen valor
    if (isAuth.value !== null) {
        body.is_auth = isAuth.value
    }

    if (authByPM.value !== null) {
        body.auth_by_pm = authByPM.value
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/get-auth-records`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {
            records.value = response.data
            isLoaded.value = true
        } else {
            isLoaded.value = false
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const unAuth = async (id) => {

    const body = { time_record_id: id }

    try {
        const response = await axios.post(`${API_BASE_URL}/unauth`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200 && response.data.msg) {
            alert(response.data.msg)
            await fetchRecords()
        } else { alert('Error al realizar la operación'); }

    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const unAuthPM = async (id) => {

    const body = { time_record_id: id }

    try {
        const response = await axios.post(`${API_BASE_URL}/unauth-pm`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200 && response.data.msg) {
            alert(response.data.msg)
            await fetchRecords()
        } else { alert('Error al realizar la operación'); }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const unAuthAll = async (id) => {

    const body = { time_record_id: id }

    try {
        const response = await axios.post(`${API_BASE_URL}/unauth-all`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200 && response.data.msg) {
            alert(response.data.msg)
            await fetchRecords()
        } else { alert('Error al realizar la operación'); }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}

const deleteRecord = async (id) => {

    const body = { time_record_id: id }

    try {
        const response = await axios.post(`${API_BASE_URL}/remove-time-record-2`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200 && response.data.msg) {
            alert(response.data.msg)
            await fetchRecords()
        } else { alert('Error al realizar la operación'); }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

onMounted(
    async () => {
        setCurrentWeek()
        await fetchRecords()
    }
)

</script>